import React from 'react';

const PricingSection = ({ 
  prixAchatHT, 
  prixAchatTTC, 
  setPrixAchatTTC, 
  prixVenteHT, 
  price, 
  setPrice 
}) => {
  return (
    <div className="sm:col-span-6">
      <h4 className="text-sm font-medium text-gray-700 mb-4">Informations de prix</h4>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
        {/* Prix Achat HT */}
        <div>
          <label htmlFor="prixAchatHT" className="block text-sm font-medium text-gray-700 mb-1">
            Prix d'achat HT (TND) <span className="text-xs text-gray-500">(calculé)</span>
          </label>
          <div className="mt-1 relative rounded-md shadow-sm">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <span className="text-gray-500 sm:text-sm">TND</span>
            </div>
            <input
              type="number"
              name="prixAchatHT"
              id="prixAchatHT"
              min="0"
              step="0.01"
              value={prixAchatHT}
              className="block w-full pl-11 py-2 focus:ring-[#174540] focus:border-[#174540] sm:text-sm border border-gray-300 rounded-md bg-gray-100"
              readOnly
            />
          </div>
        </div>

        {/* Prix Achat TTC */}
        <div>
          <label htmlFor="prixAchatTTC" className="block text-sm font-medium text-gray-700 mb-1">
            Prix d'achat TTC (TND) <span className="text-red-500">*</span>
          </label>
          <div className="mt-1 relative rounded-md shadow-sm">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <span className="text-gray-500 sm:text-sm">TND</span>
            </div>
            <input
              type="number"
              name="prixAchatTTC"
              id="prixAchatTTC"
              min="0"
              step="0.01"
              value={prixAchatTTC}
              onChange={(e) => setPrixAchatTTC(e.target.value)}
              placeholder="0.00"
              className="block w-full pl-11 py-2 focus:ring-[#174540] focus:border-[#174540] sm:text-sm border border-gray-300 rounded-md"
              required
            />
          </div>
        </div>

        {/* Prix Vente HT */}
        <div>
          <label htmlFor="prixVenteHT" className="block text-sm font-medium text-gray-700 mb-1">
            Prix de vente HT (TND) <span className="text-xs text-gray-500">(calculé)</span>
          </label>
          <div className="mt-1 relative rounded-md shadow-sm">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <span className="text-gray-500 sm:text-sm">TND</span>
            </div>
            <input
              type="number"
              name="prixVenteHT"
              id="prixVenteHT"
              min="0"
              step="0.01"
              value={prixVenteHT}
              className="block w-full pl-11 py-2 focus:ring-[#174540] focus:border-[#174540] sm:text-sm border border-gray-300 rounded-md bg-gray-100"
              readOnly
            />
          </div>
        </div>

        {/* Prix Vente TTC */}
        <div>
          <label htmlFor="price" className="block text-sm font-medium text-gray-700 mb-1">
            Prix de vente TTC (TND) <span className="text-red-500">*</span>
          </label>
          <div className="mt-1 relative rounded-md shadow-sm">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <span className="text-gray-500 sm:text-sm">TND</span>
            </div>
            <input
              type="number"
              name="price"
              id="price"
              min="0"
              step="0.01"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
              placeholder="0.00"
              className="block w-full pl-11 py-2 focus:ring-[#174540] focus:border-[#174540] sm:text-sm border border-gray-300 rounded-md"
              required
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricingSection;